module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/7c90d807c35e074b8ed96061b71726e8.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/silver.png
// module id = RiHm
// module chunks = 0